export const containerStyles = {
  width: 'auto',
  maxWidth: '392px'
};

export const imageContainerStyles = theme => ({
  maxWidth: '392px',

  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%'
  }
});

export const imagePreviewStyles = isOutgoing => ({
  borderRadius: isOutgoing ? '10px 3px 10px 10px' : '3px 10px 10px 10px',
  display: 'block',
  width: '100%'
});

export const viewLargerButtonStyles = {
  mt: 0.5,
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '13px',
  lineHeight: '22px',
  letterSpacing: '0.46px',
  textTransform: 'none',
  color: 'secondary.main'
};

export const viewLargerButtonIconStyles = { width: '16px', mr: 1 };
